
$(function () {
	$('#accordion').on('shown.bs.collapse', function (e) {
		var offset = $(e.target).closest('.panel').offset();
		if(offset)
            var scrollHeight = offset.top-50;
            if(parseInt($('body').css('paddingTop')) > 0){
                scrollHeight = scrollHeight - parseInt($('body').css('paddingTop'));
            }
			$('html,body').animate({scrollTop : scrollHeight},'fast');
	});
});

$('input:checkbox[name="guest-shipping_to"]').on('change', function() {

	$('#newGuestAddress').toggleClass('hidden');

	var bootstrapValidator = $('#guestForm').data('bootstrapValidator'),
		shipNewAddress     = ($(this).is(':checked') == true);

	bootstrapValidator.enableFieldValidators('differentGuestSalutation', shipNewAddress)
		.enableFieldValidators('differentGuestName', shipNewAddress)
		.enableFieldValidators('differentGuestSurname', shipNewAddress)
		.enableFieldValidators('differentGuestStreetandnumber', shipNewAddress)
		.enableFieldValidators('differentGuestZipcode', shipNewAddress)
		.enableFieldValidators('differentGuestCity', shipNewAddress)
		.enableFieldValidators('differentGuestCountry', shipNewAddress);
});

$(document).on('click', '.payment-selector', function () {
    if($(this).hasClass('shipping-address') &&  $(this).hasClass('payment-form-label')){
		$('.payment-form').not($(this)).addClass('hidden');
		$(this).siblings('.payment-form').removeClass('hidden');
		$('.payment-selector').not($(this)).not('.payment-form * .payment-label').addClass('hidden');
		$('.payment-selector').not($(this)).siblings('.payment-footer').addClass('hidden');
		$('#payment-changer').removeClass('hidden');
    }else if(!$(this).hasClass('shipping-address') &&  $(this).hasClass('payment-form-label')){
        $('.payment-form').not($(this)).addClass('hidden');
        $(this).siblings('.payment-form').removeClass('hidden');
        $('.payment-selector').not($(this)).not('.payment-form * .payment-label').addClass('hidden');
        $('.payment-selector').not($(this)).siblings('.payment-footer').addClass('hidden');
        $('#payment-changer').removeClass('hidden');

		// quick fix until we have the new checkout: show all possible payment options
		var $paymentOptions = $(this).siblings('.payment-form');
		$paymentOptions.removeClass('hidden');
		$('.payment-selector', $paymentOptions).removeClass('hidden');
    }
});

$(document).on('shopgateFramework.forms.payment.paymentMethodChanged shopgateFramework.forms.adddress.addressChanged', '.payment-selector', function (e) {
	e.stopPropagation();

	$('.payment-selector').not($(this)).removeClass('checked');
	$(this).addClass('checked');

	if ( $(this).is('.payment-form * .payment-label') ) {
		$('.payment-selector').not($(this)).not('.payment-form-label').addClass('hidden');
		$('#collapseOne').collapse('hide');
		$('#payment-changer').removeClass('hidden');
	} else {
		if (!layoutFeatures.checkoutNew) {	// Only hide for the old checkout form
			$('.payment-selector').not($(this)).addClass('hidden');
			$('.payment-form').addClass('hidden');
			$('.payment-footer').addClass('hidden');
			$('#payment-changer').removeClass('hidden');

			if (this.id == 'PPAL_PLUS') {
				$('#paypal-payment').removeClass('hidden');
			}
		}
	}

	// quick fix until we have the new checkout: show all possible payment options
	var $parent = $(this).closest('.payment-form');
	$parent.removeClass('hidden');
	$('.payment-selector', $parent).removeClass('hidden');

    if ($('#payment-changer').length > 0) {
        var scrollHeight = $("#payment-changer").offset().top-10;
        if(parseInt($('body').css('paddingTop')) > 0){
            scrollHeight = scrollHeight - parseInt($('body').css('paddingTop'));
        }
        $("html, body").animate( {scrollTop : scrollHeight }, 'slow' );
    }
});

$(document).on('shopgateFramework.forms.payment.paymentMethodChangePending shopgateFramework.forms.adddress.addressChangePending', '.payment-selector', function () {
	$(this).removeClass('checked').find('.preloader').show();
});

$(document).on('shopgateFramework.forms.payment.paymentMethodChangeComplete shopgateFramework.forms.adddress.addressChangeComplete', '.payment-selector', function () {
	$(this).find('.preloader').hide();
});

$(document).on('shopgateFramework.forms.shipping.shippingMethodChanged', '.shipping-selector', function () {
	$('.shipping-selector').not($(this)).removeClass('checked');
	$(this).addClass('checked');
});

$(document).on('shopgateFramework.forms.shipping.shippingMethodChangePending', '.shipping-selector', function () {
	$(this).find('.preloader').show();
});

$(document).on('shopgateFramework.forms.shipping.shippingMethodChangeComplete', '.shipping-selector', function () {
	$(this).find('.preloader').hide();
});

$(document).on('click', '.address-label', function () {
	var addressPanel = $(this);

    if(addressPanel.hasClass('checked')){
        addressPanel.removeClass('checked');
    }else{
        addressPanel.addClass('checked');
    }

    if(addressPanel.hasClass('checked')){
        // die anderen nicht checken und verstecken
        $('.address-label').not(addressPanel).removeClass('checked');
        $('.payment-form').not(addressPanel).addClass('hidden');
        // sich selbst zeigen
        addressPanel.siblings('.payment-form').removeClass('hidden');
        var scrollHeight = addressPanel.offset().top-10;
        if(parseInt($('body').css('paddingTop')) > 0){
            scrollHeight = scrollHeight - parseInt($('body').css('paddingTop'));
        }
        $("html, body").animate( {scrollTop : scrollHeight }, 'slow' );
    }else{
        // sich selbst verstecken
        addressPanel.siblings('.payment-form').addClass('hidden');
    }

    $('#payment-changer').removeClass('hidden');

});

$(document).on('click', '.edit-toggle', function (e) {
	e.stopPropagation();

	$('.address-label').removeClass('checked');
	$('.btn-delete').toggleClass('hidden');

});

$(document).on('click', '.btn-delete', function (e) {
	e.stopPropagation();

	$(this).parent('label').remove();

});

$(document).on('click', '#payment-changer', function (e) {
	e.preventDefault();

	$('.payment-selector').removeClass('hidden');
	$('.payment-footer').removeClass('hidden');
	$('#collapseOne').collapse('show');

});



// WEBPACK FOOTER //
// ./Library/1.0/common/forms.min.js